export class AnimationStates {
  public static closed = 'closed';
  public static open = 'open';
}
